import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NumericKeypadComponent } from './components/numeric-keypad/numeric-keypad.component';
import { MaterialModules } from './material';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ProfileAvatarComponent } from './components/profile-avatar/profile-avatar.component';

const vendorModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];

const appComponents = [
  NumericKeypadComponent,
  ConfirmDialogComponent,
  ProfileAvatarComponent,
];
@NgModule({
  declarations: [...appComponents],
  imports: [...vendorModules, ...MaterialModules],
  exports: [...vendorModules, ...MaterialModules, ...appComponents],
})
export class SharedModule {}
